import api from '@/lib/api';
import type { AdminSubscriptionRow } from '@/types/admin';

export interface SubscriptionsQuery {
  status?: string;
  plan?: string;
}

export async function fetchSubscriptions(
  params: SubscriptionsQuery,
): Promise<AdminSubscriptionRow[]> {
  const { data } = await api.get('/admin/subscriptions', { params });
  const body = data as { data?: AdminSubscriptionRow[] } | AdminSubscriptionRow[];
  return Array.isArray(body) ? body : body.data ?? [];
}

export interface UpdateSubscriptionPayload {
  plan?: string;
  docUploadMaxBytesOverride?: number | null;
}

export async function updateSubscription(
  id: string,
  payload: UpdateSubscriptionPayload,
): Promise<AdminSubscriptionRow> {
  const { data } = await api.patch(`/admin/subscriptions/${id}`, payload);
  return (data?.data ?? data) as AdminSubscriptionRow;
}
